import { useState } from 'react';

const useDefaultValue = (defaultValue, value, setValue) => {
  const [internalValue, setInternalValue] = useState(defaultValue || '');
  if (value !== undefined && value !== null) {
    if (setValue) {
      return [value, setValue];
    }
    return [value];
  }
  return [internalValue, setInternalValue];
};

export { useDefaultValue as u };
//# sourceMappingURL=use-default-value.js.map
